import React from "react";
import { Link } from "react-router-dom";
import clausePage from "./ClausePage.module.css";
//icons
import ComputerIcon from "@material-ui/icons/Computer";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
import ListIcon from "@material-ui/icons/List";
import CreateIcon from "@material-ui/icons/Create";
// end icons

const Clause8 = () => {
  return (
    <>
      <div
        className="divflex"
        style={{ fontSize: "24px", textTransform: "uppercase" }}
      >
        Handling Abnormility In Quality
      </div>
      <main className={`${clausePage.container} ${clausePage.main}`}>
        <div>
          <Link to="/masterProcedureList?category=clause-8" className="panel">
            <ListIcon style={{ fontSize: "3rem", color: "maroon" }} />
          </Link>
          <p className="card-btn-para">
            Master <span className="card-btn-span">Procedure</span>
          </p>
        </div>

        <div>
          <Link to="/scrapNoteList" className="panel">
            <FeaturedPlayListIcon
              style={{ fontSize: "3rem", color: "#003566" }}
            />
          </Link>
          <p className="card-btn-para">
            Scrap Note <span className="card-btn-span">Reports</span>
          </p>
        </div>
        <div>
            <Link to="/scrapLocations" className="panel">
              <CreateIcon style={{ fontSize: "3rem", color: "#003566" }} />
            </Link>
            <p className="card-btn-para">
              ADD
              <span className="card-btn-span">Scrap Location</span>
            </p>
        </div>
        <div>
          <Link to="/create_edit_customer_compalint/list" className="panel">
            <ComputerIcon style={{ fontSize: "3rem", color: "#343a40" }} />
          </Link>
          <p className="card-btn-para">
            Customer
            <span className="card-btn-span">Complaint Tracker</span>
          </p>
        </div>
      </main>
    </>
  );
};

export default Clause8;
